export default "__VITE_ASSET__D3uYzQ3a__"